import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const DuplicateCheckResults = ({ results, onSelectMatch, onProceed }) => {
  const getConfidenceColor = (score) => {
    if (score >= 90) return 'text-error bg-error/10';
    if (score >= 70) return 'text-warning bg-warning/10';
    return 'text-success bg-success/10';
  };

  const getConfidenceIcon = (score) => {
    if (score >= 90) return 'AlertCircle';
    if (score >= 70) return 'AlertTriangle';
    return 'CheckCircle';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Duplikatsprüfung</h3>
        <div className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium ${results?.matches?.length > 0 ? 'bg-warning/10 text-warning' : 'bg-success/10 text-success'}`}>
          <Icon name={results?.matches?.length > 0 ? 'AlertTriangle' : 'CheckCircle'} size={16} />
          <span>{results?.matches?.length} Übereinstimmungen gefunden</span>
        </div>
      </div>
      {results?.matches?.length === 0 ? (
        <div className="text-center py-12">
          <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="CheckCircle" size={32} color="var(--color-success)" />
          </div>
          <h4 className="text-lg font-semibold text-foreground mb-2">Keine Duplikate gefunden</h4>
          <p className="text-sm text-muted-foreground mb-6">Die Kundendaten sind eindeutig. Sie können mit der ID-Generierung fortfahren.</p>
          <button
            onClick={onProceed}
            className="px-6 py-3 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors font-medium"
          >
            Mit Generierung fortfahren
          </button>
        </div>
      ) : (
        <div className="space-y-4">
          <div className="bg-warning/5 border border-warning/20 rounded-lg p-4 mb-6">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-foreground mb-1">Mögliche Duplikate erkannt</p>
                <p className="text-xs text-muted-foreground">Bitte überprüfen Sie die folgenden Übereinstimmungen, bevor Sie fortfahren. Wählen Sie einen vorhandenen Datensatz aus oder fahren Sie mit der Erstellung einer neuen ID fort.</p>
              </div>
            </div>
          </div>

          {results?.matches?.map((match) => (
            <div
              key={match?.id}
              className="border border-border rounded-lg p-4 hover:border-primary/50 transition-colors cursor-pointer"
              onClick={() => onSelectMatch(match)}
            >
              <div className="flex items-start gap-4">
                <Image
                  src={match?.photo}
                  alt={match?.photoAlt}
                  className="w-16 h-16 rounded-lg object-cover border border-border flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-4 mb-3">
                    <div>
                      <h4 className="text-base font-semibold text-foreground">{match?.fullName}</h4>
                      <p className="text-sm text-muted-foreground mt-0.5">ID: {match?.uniqueId}</p>
                    </div>
                    <div className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-xs font-medium ${getConfidenceColor(match?.confidenceScore)}`}>
                      <Icon name={getConfidenceIcon(match?.confidenceScore)} size={14} />
                      <span>{match?.confidenceScore}% Übereinstimmung</span>
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-4 text-sm">
                    <div>
                      <span className="text-muted-foreground">Geburtsdatum:</span>
                      <span className="ml-2 text-foreground font-medium">{match?.dateOfBirth}</span>
                    </div>
                    <div>
                      <span className="text-muted-foreground">Adresse:</span>
                      <span className="ml-2 text-foreground font-medium">{match?.address}</span>
                    </div>
                    <div>
                      <span className="text-muted-foreground">Beruf:</span>
                      <span className="ml-2 text-foreground font-medium">{match?.occupation}</span>
                    </div>
                  </div>

                  {match?.matchingFields?.length > 0 && (
                    <div className="flex items-center gap-2 mt-3 pt-3 border-t border-border">
                      <Icon name="Link" size={14} color="var(--color-muted-foreground)" />
                      <span className="text-xs text-muted-foreground">
                        Übereinstimmende Felder: {match?.matchingFields?.join(', ')}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}

          <div className="flex items-center gap-3 pt-4 border-t border-border">
            <button
              onClick={onProceed}
              className="flex-1 px-4 py-3 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors font-medium"
            >
              Trotzdem neue ID erstellen
            </button>
            <button
              className="px-4 py-3 border border-border rounded-md hover:bg-muted transition-colors text-foreground font-medium"
            >
              Prüfung abbrechen
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DuplicateCheckResults;